export const JOINT_ACCOUNT_TYPE = {
  JTWROS: 'JOINT_TENANTS_WITH_RIGHT_OF_SURVIVORSHIP',
  TIC: 'TENANTS_IN_COMMON',
  COMMUNITY_PROPERTY: 'JOINT_COMMUNITY_PROPERTY',
  JOINT_TENANTS_BY_THE_ENTIRETY: 'JOINT_TENANTS_BY_THE_ENTIRETY',
}

export type JointAccountType = (typeof JOINT_ACCOUNT_TYPE)[keyof typeof JOINT_ACCOUNT_TYPE]
